import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const DividerIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps, ...props
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 2"
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}
    >
      <line y1={1} x2={24} y2={1} stroke={color} strokeWidth={2} />
    </svg>
  );
};

export default DividerIcon;